import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';
import queryString from 'query-string';
import moment from 'moment';

import { openrtbMediaStatistics } from 'lib/api/openrtb';
import {
  makeRowColumn,
  getHeadObj,
  converParameters,
  replaceZero,
  converDisplayValue,
  getHost,
} from 'lib/commonLib';

import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import SortLabelWrap from 'components/molecules/MbTable/SortLabelWrap';

import RtbItlTpCodeFilter from './RtbItlTpCodeFilter';

const MediaStatistics = (props) => {
  const { location, handlePortalUrl, commonCustomized } = props;
  const { tp_code } = queryString.parse(location.search);
  const { common } = useSelector(({ common }) => ({ common: common }));

  const { t } = useTranslation();

  let initParams = {
    order: 'ADVRTS_AMT',
    sort: 'desc',
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    itlTpCode: !!tp_code ? tp_code : '04',
    pltfomTpCode: 'all',
    appCate: 'all',
    trackerFlag: 'Y',
  };

  const initCustomized = {
    ...commonCustomized,
    MEDIA_SITE_NO: { merged: true },
    MEDIA_SCRIPT_NO: { merged: true },
    TAG_ID: { merged: true },
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [tempParams, setTempParams] = useState(initParams);
  const [customized, setCustomized] = useState(initCustomized);

  useEffect(() => {
    handleCustom(initParams);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setInitialization(true);
      setParams(initParams);
      handleCustom(initParams);
    }
  };

  const getParam = () => {
    if (JSON.stringify(params) !== JSON.stringify(tempParams)) {
      setParams(tempParams);
      handleCustom(tempParams);
    }
  };

  const getTableParam = (newParams, name) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
      setTempParams(newParams);
      handleCustom(newParams);
    }
  };

  const getTempParam = (newParams) => {
    if (JSON.stringify(tempParams) !== JSON.stringify(newParams)) {
      setTempParams(newParams);
    }
  };

  const handleSortChange = (propsParams, orderKey) => {
    const { order, sort } = propsParams;
    const isDesc = order === orderKey && sort === 'desc';
    const converSort = isDesc ? 'asc' : 'desc';
    const newParams = { ...propsParams, order: orderKey, sort: converSort };
    setParams(newParams);
    handleCustom(newParams);
  };

  const handleCustom = (propsParams) => {
    let newCustomized = { ...initCustomized };
    newCustomized = {
      ...newCustomized,
      SITE_NAME: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'SITE_NAME');
          const bodyItem2 = getHeadObj(headsMap, 'MEDIA_SCRIPT_NO');
          const bodyItem3 = getHeadObj(headsMap, 'TAG_ID');
          const isTotal = rowObj['FIXED'] !== 0;
          const data = (
            <>
              {makeRowColumn(
                rowObj['SITE_NAME'],
                bodyItem1.type,
                bodyItem1.format
              )}
              <br />
              {makeRowColumn(
                rowObj['MEDIA_SCRIPT_NO'],
                bodyItem2.type,
                bodyItem2.format
              )}
              {' / '}
              {makeRowColumn(
                rowObj['TAG_ID'],
                bodyItem3.type,
                bodyItem3.format
              )}
            </>
          );
          let showWindowUrl;
          if (isTotal) {
            showWindowUrl = converParameters({
              url: getHost('new') + '/report/openrtb/day',
              sDate: propsParams['sDate'],
              eDate: propsParams['eDate'],
              itlTpCode: propsParams['itlTpCode'],
              pltfomTpCode: propsParams['pltfomTpCode'],
              advrtsPrdtCode: propsParams['advrtsPrdtCode'],
              advrtsTpCode: propsParams['advrtsTpCode'],
              mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
              popGroup: 'openRtbMediaPopup',
              isPop: 1,
              // Openrtb: 1,
            });
          }
          return isTotal ? (
            <IconAreaWrap
              text={data}
              icon="faExternalLink"
              toolTipTitle={t('해당 지면의 일자별 통계')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          ) : rowObj['FIXED'] === 0 ? (
            t('합계')
          ) : (
            data
          );
        },
      },
      CLICK_CNT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'CLICK_CNT');
          const isTotal = rowObj['FIXED'] !== 0;
          const data = makeRowColumn(
            rowObj['CLICK_CNT'],
            bodyItem1.type,
            bodyItem1.format
          );
          let showWindowUrl;
          let result;
          if (isTotal) {
            showWindowUrl = converParameters({
              url: getHost('new') + '/report/adver/statistics',
              sDate: propsParams['sDate'],
              eDate: propsParams['eDate'],
              itlTpCode: propsParams['itlTpCode'],
              pltfomTpCode: propsParams['pltfomTpCode'],
              advrtsPrdtCode: propsParams['advrtsPrdtCode'],
              advrtsTpCode: propsParams['advrtsTpCode'],
              mediaScriptNo: rowObj['MEDIA_SCRIPT_NO'],
              table: 'kakao_popup',
              popGroup: 'adver',
              isPop: 1,
              uri: '/report/adver/statistics',
              baseAddress: '/v2/openrtb/manage_openrtb_media_report.php',
            });
            result = (
              <IconAreaWrap
                text={data}
                icon={isTotal && !rowObj.isChild && 'faExternalLink'}
                toolTipTitle={t('광고주별 통계')}
                onClick={(e) => handlePortalUrl(showWindowUrl)}
              />
            );
          } else {
            result = data;
          }
          return result;
        },
      },
      ORDER_CNT: {
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'ORDER_CNT');
          const isTotal = rowObj['FIXED'] !== 0;
          const data = makeRowColumn(
            rowObj['ORDER_CNT'],
            bodyItem1.type,
            bodyItem1.format
          );
          let showWindowUrl;
          if (isTotal) {
            showWindowUrl = converParameters({
              url:
                getHost() +
                '/v2/popup/daily_conversion.php',
              gb: converDisplayValue(
                common.productCodeList,
                propsParams['advrtsPrdtCode'],
                propsParams['advrtsTpCode']
              ),
              gb_web: replaceZero(propsParams['pltfomTpCode']),
              st_date: moment(propsParams['sDate']).format('YYYY-MM-DD'),
              en_date: moment(propsParams['eDate']).format('YYYY-MM-DD'),
              mc: rowObj['MEDIA_SCRIPT_NO'],
              tp_code: propsParams['itlTpCode'],
              mcgb: 'R',
            });
          }
          return isTotal ? (
            <IconAreaWrap
              text={data}
              icon="faExternalLink"
              toolTipTitle={t('해당 날짜의 컨버전리스트')}
              onClick={(e) => handlePortalUrl(showWindowUrl)}
            />
          ) : (
            data
          );
        },
      },
      BID_REQ_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
                <>
                  <SortLabelWrap
                      params={propsParams}
                      label={getHeadObj(headsMap, 'BID_REQ_CNT').label}
                      orderKey="BID_REQ_CNT"
                      onClick={(e) => handleSortChange(propsParams, 'BID_REQ_CNT')}
                  />
                  <br />
                  {getHeadObj(headsMap, 'BID_CNT').label}
                  <br />
                  {getHeadObj(headsMap, 'BID_RATE').label}
                </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const bodyItem1 = getHeadObj(headsMap, 'BID_REQ_CNT');
          const bodyItem2 = getHeadObj(headsMap, 'BID_CNT');
          const bodyItem3 = getHeadObj(headsMap, 'BID_RATE');
          return (
              <>
                {makeRowColumn(
                    rowObj['BID_REQ_CNT'],
                    bodyItem1.type,
                    bodyItem1.format
                )}
                <br />
                {makeRowColumn(rowObj['BID_CNT'], bodyItem2.type, bodyItem2.format)}
                <br />
                {makeRowColumn(
                    rowObj['BID_RATE'],
                    bodyItem3.type,
                    bodyItem3.format
                )}
              </>
          );
        },
      },
      BID_CNT: { merged: true },
      BID_RATE: { merged: true },
    };
    setCustomized(newCustomized);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          params={tempParams}
          getParam={getTempParam}
          useExternalFilter={false}
          pltfomTpCodeDetailFilter={['03', '04']}
          externalType="select"
        />
        <RtbItlTpCodeFilter params={tempParams} getTempParam={getTempParam} />
        <NewButton type="filterButton" onClick={getParam} disableRipple>
          {t('검색')}
        </NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        dataReqPromise={openrtbMediaStatistics}
        getParam={getTableParam}
        customized={customized}
        isIncludingTotal
      />
    </>
  );
};

export default withRouter(MediaStatistics);
